module.exports = {"411104001":"召陵区天桥街街道","411104002":"召陵区翟庄街道","411104003":"召陵区东城街道","411104100":"召陵区召陵镇","411104102":"召陵区万金镇","411104103":"召陵区老窝镇","411104104":"姬石镇","411104105":"召陵区青年镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411104.json
// module id = 1748
// module chunks = 0